/**
 * The identifiers used to identify telemetry values.
 */
export class TelemetryIdentifiers {

	public static readonly EVENT_UNAUTHENTICATED_REQUEST = "unauthenticated-request";

	public static readonly EVENT_LOGIN = "login";

	public static readonly EVENT_LOGOUT = "logout";

	public static readonly EVENT_FORGOT_PASSWORD = "forgot-password";

	public static readonly EVENT_FORGOT_PASSWORD_SEND_EMAIL = "forgot-password-send-email";

	public static readonly EVENT_FORGOT_PASSWORD_RESET_PASSWORD = "forgot-password-reset-password";

	public static readonly EVENT_LOGGED_IN_ELSEWHERE = "logged-in-elsewhere";

	public static readonly METRIC_USER_STATE_READ: string = "user-state-read";

	public static readonly METRIC_USER_STATE_WRITE: string = "user-state-write";

	public static readonly METRIC_DISPATCHED_SERVICES_STATE_READ: string = "dispatched-services-state-read";

	public static readonly METRIC_DISPATCHED_SERVICES_STATE_WRITE: string = "dispatched-services-state-write";

	public static readonly METRIC_DISPATCHED_SERVICES_FRAGMENT_AND_SAVE_CAPTURED_BINARY_DATA: string = "dispatched-services-fragment-and-save-captured-binary-data";

	public static readonly METRIC_DISPATCHED_SERVICES_FRAGMENT_AND_SAVE_ALL_CAPTURED_BINARY_DATA: string = "dispatched-services-fragment-and-save-all-captured-binary-data";

	public static readonly METRIC_DISPATCHED_SERVICES_CACHED_DATA_READ: string = "dispatched-services-cached-data-read";

	public static readonly METRIC_DISPATCHED_SERVICES_CACHED_DATA_WRITE: string = "dispatched-services-cached-data-write";

	public static readonly METRIC_DOCUMENT_DATA_READ: string = "document-data-read";

	public static readonly METRIC_DOCUMENT_DATA_WRITE: string = "document-data-write";

	public static readonly METRIC_DOCUMENT_DATA_DELETE: string = "document-data-delete";

	/** The metric for deleted binary fragment data. */
	public static readonly METRIC_BINARY_FRAGMENT_DATA_DELETE: string = "binary-fragment-data-delete";

	public static readonly METRIC_VERSION_UPDATE_FAILED = "version-update-failed";

	public static readonly METRIC_VERSION_UPDATE_SUCCESSFUL = "version-update-successful";

	public static readonly METRIC_BACKGROUND_SYNC_PROCESSED = "background-sync-processed";

	public static readonly EVENT_SELECTED_AGENT_CROWNID: string = "selected-agent-crownid";

	public static readonly EVENT_OPEN_DRIVER_FILTER: string = "open-driver-filter";

	public static readonly EVENT_OPEN_SURCHARGE_FILTER: string = "open-surcharge-filter";

	public static readonly EVENT_OPEN_ROUTE_FILTER: string = "open-route-filter";

	public static readonly EVENT_OPEN_MOVE_TYPE_FILTER: string = "open-move-type-filter";

	public static readonly EVENT_OPEN_STOP_STATUS_FILTER: string = "open-stop-status-filter";

	public static readonly EVENT_OPEN_DISPATCH_TERMINAL_FILTER: string = "open-dispatch-terminal-filter";

	public static readonly EVENT_OPEN_SERVICE_LEVELS_FILTER: string = "open-service-levels-filter";

	/** The event for opening the hazmat filter. */
	public static readonly EVENT_OPEN_HAZMAT_FILTER: string = "open-hazmat-filter";

	/** The event for opening the holiday filter. */
	public static readonly EVENT_OPEN_HOLIDAY_FILTER: string = "open-holiday-filter";

	/** The event for opening the special filter. */
	public static readonly EVENT_OPEN_SPECIAL_FILTER: string = "open-special-filter";

	public static readonly EVENT_OPEN_MAP_FILTER_PANE: string = "open-map-filter-pane";

	public static readonly EVENT_UPDATE_MAP_WITH_FILTERS: string = "update-map-with-filters";

	public static readonly EVENT_CALCULATE_ETAS: string = "calculate-etas";

	public static readonly EVENT_OPTIMIZE_ROUTE: string = "optimize-route";

	public static readonly EVENT_SEND_AND_DISPATCH_ROUTE: string = "send-and-dispatch-route";

	public static readonly EVENT_SEND_ROUTE: string = "send-route";

	public static readonly EVENT_DISPATCH_ROUTE: string = "dispatch-route";

	public static readonly EVENT_UPSERT_ROUTE_MANIFEST: string = "upsert-route-manifest";

	public static readonly EVENT_SAVE_ROUTE: string = "save-route";

	public static readonly EVENT_DELETE_ROUTE: string = "delete-route";

	public static readonly EVENT_ADD_BREAK_TO_ROUTE: string = "add-break-to-route";

	public static readonly EVENT_OVERRIDE_TIME_TO_SERVICE: string = "override-time-to-service";

	public static readonly EVENT_FILTER_ROUTE_TOTALS: string = "filter-route-totals";

	public static readonly EVENT_OPEN_ROUTE_FROM_MAP: string = "open-route-from-map";

	public static readonly EVENT_OPEN_ROUTE_FROM_DRIVER_ROUTES: string = "open-route-from-driver-routes";

	public static readonly EVENT_CREATE_NEW_ROUTE: string = "create-new-route";

	public static readonly EVENT_CREATE_NEW_ROUTE_FROM_IMPORT: string = "create-new-route-from-import";

	public static readonly EVENT_OPEN_GEOCODING_FAILURES_WINDOW: string = "open-geocoding-failures-window";

	public static readonly EVENT_SAVE_GEOCODING_FAILURE_ADDRESS_FIX: string = "save-geocoding-failure-address-fix";

	public static readonly EVENT_SAVE_GEOCODING_FAILURE_ASSIGNED_LOCATION: string = "save-geocoding-failure-assigned-location";

	public static readonly EVENT_SELECT_ADDRESS_SUGGESTION: string = "select-address-suggestion";

	public static readonly EVENT_SELECT_MAP_VIEW_FILTER: string = "select-map-view-filter";

	public static readonly EVENT_SAVE_MAP_VIEW_FILTER: string = "save-map-view-filter";

	public static readonly EVENT_DELETE_MAP_VIEW_FILTER: string = "delete-map-view-filter";

	public static readonly EVENT_SAVE_STOP_MOVE: string = "save-stop-move";

	public static readonly EVENT_CALCULATE_ALL_ETAS: string = "calculate-all-etas";

	public static readonly EVENT_CHANGE_MAP_DATE: string = "change-map-date";

	public static readonly EVENT_OPEN_SATELLITE_VIEW: string = "open-satellite-view";

	public static readonly EVENT_FILTER_VIEW_ROUTE_PLANS: string = "filter-view-route-plans";

	public static readonly EVENT_FILTER_VIEW_STOP_NUMBERS: string = "filter-view-stop-numbers";

	public static readonly EVENT_USE_GPS_HISTORY: string = "use-gps-history";

	public static readonly EVENT_OPEN_LIVE_MAP_FROM_MENU: string = "open-live-map-from-menu";

	public static readonly EVENT_SEND_DIAGNOSTICS_DATA_MENU: string = "send-diagnostics-data-menu";

	public static readonly EVENT_OPEN_TIME_TO_SERVICE_CONFIGURATION_FROM_MENU: string = "open-time-to-service-configuration-from-menu";

	public static readonly EVENT_OPEN_CROWN_X_DRIVER_FROM_MENU: string = "open-crown-x-driver-from-menu";

	/** The event for opening the Document Upload page from the navigation menu. */
	public static readonly EVENT_OPEN_DOCUMENT_UPLOAD_FROM_MENU: string = "open-document-upload-from-menu";

	/** The event for when a user selects an image storage location for an uploaded document. */
	public static readonly EVENT_DOCUMENT_UPLOAD_IMAGE_LOCATION_SELECTED: string = "document-upload-image-location-selected";

	/** The event for when uploaded documents are successfully saved. */
	public static readonly EVENT_DOCUMENT_UPLOAD_SAVE_SUCCESS: string = "document-upload-save-success";

	public static readonly EVENT_OPEN_USER_MANAGEMENT_FROM_MENU: string = "open-user-management-from-menu";

	public static readonly EVENT_OPEN_PICTURE_SLOT_CONFIGURATION_FROM_MENU: string = "open-picture-slot-configuration-from-menu";

	public static readonly EVENT_OPEN_SURVEY_FROM_MENU: string = "open-survey-from-menu";

	public static readonly EVENT_OPEN_HELP_FROM_MENU: string = "open-help-from-menu";

	public static readonly EVENT_SAVE_TIME_TO_SERVICE_CONFIGURATIONS: string = "save-time-to-service-configurations";

	public static readonly EVENT_SENDING_DIAGNOSTICS_DATA: string = "sending-diagnostics-data";

	public static readonly EVENT_SAVE_USER: string = "save-user";

	public static readonly EVENT_IMPORT_DRIVERS_FROM_CFM: string = "import-drivers-from-cfm";

	public static readonly EVENT_GET_DRIVER_PERMISSIONS: string = 'get-driver-permissions';

	public static readonly EVENT_REFRESH_DRIVER_DISPATCHED_SERVICES: string = "refresh-driver-dispatched-services";

	public static readonly EVENT_OPEN_DRIVER_SERVICES_PREVIEW_FROM_NAVIGATION_BAR: string = "open-driver-services-preview-from-navigation-bar";

	public static readonly EVENT_OPEN_DRIVER_END_OF_ROUTE_FROM_NAVIGATION_BAR: string = "open-driver-end-of-route-from-navigation-bar";

	public static readonly EVENT_OPEN_DRIVER_EN_ROUTE_TO_STOP_FROM_NAVIGATION_BAR: string = "open-driver-en-route-to-stopfrom-navigation-bar";

	public static readonly EVENT_SHOW_DRIVER_ROUTE_LIST: string = "show-driver-route-list";

	public static readonly EVENT_SHOW_DRIVER_SERVICE_DETAILS: string = "show-driver-service-details";

	public static readonly EVENT_FINISH_SERVICE_FROM_PERFORM_SERVICE_PAGE: string = "finish-service-from-perform-service-page";

	public static readonly EVENT_CANCEL_FROM_PERFORM_SERVICE_PAGE: string = "cancel-from-perform-service-page";

	public static readonly EVENT_DRIVER_COMPLETE_ROUTE: string = "driver-complete-route";

	public static readonly EVENT_DRIVER_RETURN_TO_PREVIEW: string = "driver-return-to-preview"

	public static readonly EVENT_DRIVER_LOGOUT: string = "driver-logout";

	public static readonly EVENT_ACCEPT_ALL_SERVICES_FROM_SERVICE_PREVIEW_TOOLBAR: string = "accept-all-services-from-service-preview-toolbar";

	public static readonly EVENT_APPLY_FILTERS_FROM_SERVICE_PREVIEW_TOOLBAR: string = "apply-filters-from-service-preview-toolbar";

	public static readonly EVENT_START_ROUTE_FROM_SERVICE_PREVIEW_PAGE: string = "start-route-from-service-preview-page";

	public static readonly EVENT_ACCEPT_SERVICE_FROM_SERVICE_PREVIEW_PAGE: string = "accept-service-from-service-preview-page";

	public static readonly EVENT_SERVICE_REORDERED_ON_SERVICE_PREVIEW_PAGE: string = "service-reordered-from-service-preview-page";

	public static readonly EVENT_ARRIVE_SERVICE_FROM_EN_ROUTE_TO_STOP_PAGE: string = "arrive-service-from-en-route-to-stop-page"

	public static readonly EVENT_CANCEL_SERVICE_ARRIVAL_FROM_EN_ROUTE_TO_STOP_PAGE: string = "cancel-service-arrival-from-en-route-to-stop-page"

	public static readonly EVENT_PERFORM_SERVICE_FROM_EN_ROUTE_TO_STOP_PAGE: string = "perform-service-from-en-route-to-stop-page"

	public static readonly EVENT_CANNOT_COMPLETE_NOTES_SAVED_FROM_EN_ROUTE_TO_STOP_PAGE: string = "cannot-complete-notes-saved-from-en-route-to-stop-page"

	public static readonly EVENT_ENTER_EMAIL_ADDRESSES_FOR_SIGNED_EDOCS_ON_PERFORM_SERVICE_PAGE: string = "enter-email-addresses-for-signed-edocs-on-perform-service-page";

	public static readonly EVENT_EMAIL_TRIGGERED_FOR_SIGNED_EDOCS_ON_COMPLETE_REVIEW_PAGE: string = "email-triggered-for-signed-edocs-on-complete-review-page";

	public static readonly EVENT_SEND_DRIVER_DIAGNOSTICS: string = "send-driver-diagnostics";

	public static readonly EVENT_INSTALL_PWA_COMPLETE: string = "install-pwa-complete";

	public static readonly EVENT_INSTALL_PWA_TRIGGERED = "install-pwa-triggered";

	public static readonly EVENT_INSTALL_PWA_DISMISSED = "install-pwa-dismissed";

	public static readonly EVENT_MANUAL_CHECK_FOR_UPDATES_TRIGGERED = "manual-check-for-updates-triggered";

	public static readonly EVENT_VERSION_UPDATE_FAILED = "version-update-failed";

	public static readonly EVENT_VERSION_UPDATE_SUCCESSFUL = "version-update-successful";

	public static readonly EVENT_FILE_CAPTURE_CONFIGURATION_CACHE_UPDATED = "file-capture-configuration-cache-updated";

	public static readonly EVENT_CONFIRM_VERSION_UPDATE = "confirm-version-update";

	public static readonly EVENT_POSTPONE_VERSION_UPDATE = "postpone-version-update";

	public static readonly EVENT_REPROMPT_FOR_VERSION_UPDATE = "reprompt-for-version-update";

	public static readonly EVENT_PROMPT_AFTER_SERVICE_COMPLETION_FOR_VERSION_UPDATE = "prompt-after-service-completion-for-version-update";

	public static readonly EVENT_PROMPT_ON_LOGIN_FOR_VERSION_UPDATE = "prompt-on-login-for-version-update";

	/** The event for deleting all data on the client for orphaned services that no longer exists. */
	public static readonly EVENT_DELETE_ALL_DATA_FOR_ORPHANED_SERVICE = "delete-all-data-for-orphaned-service";

	/** The event for deleting all binary data sync data on the client when the service has an image save error. */
	public static readonly EVENT_DELETE_ALL_BINARY_METADATA_SYNC_DATA_WHEN_IMAGE_SAVE_ERROR = "delete-all-binary-metadata-sync-data-when-image-save-error";

	/** The event for timing out on End of Route due to stalled syncing. */
	public static readonly EVENT_END_OF_ROUTE_SYNC_TIMEOUT = "end-of-route-sync-timeout";

	/** The event for when a service has been unaccepted. */
	public static readonly EVENT_UNACCEPT_SERVICE_FROM_SERVICE_PREVIEW_PAGE: string = "unaccept-service-from-service-preview-page";

	/* The event for when a service has the document service action completed. */
	public static readonly EVENT_DOCUMENT_SERVICE_ACTION_COMPLETED: string = "document-service-action-completed";

	/* The event for when a service has the osd service action completed. */
	public static readonly EVENT_OSD_SERVICE_ACTION_COMPLETED: string = "osd-service-action-completed";

	/* The event for when a service has the photos service action completed. */
	public static readonly EVENT_PHOTOS_SERVICE_ACTION_COMPLETED: string = "photos-service-action-completed";

	/* The event for when a service has the signature service action completed. */
	public static readonly EVENT_SIGNATURE_SERVICE_ACTION_COMPLETED: string = "signature-service-action-completed";

	/* The event for when a service has the signer service action completed. */
	public static readonly EVENT_SIGNER_SERVICE_ACTION_COMPLETED: string = "signer-service-action-completed";

	/* The event for when a service has the notes service action completed. */
	public static readonly EVENT_NOTES_SERVICE_ACTION_COMPLETED: string = "notes-service-action-completed";

	/** The event for when a background operation is added to be monitored. */
	public static readonly EVENT_BACKGROUND_OPERATION_ADDED_TO_MONITOR = "background-operation-added-to-monitor";

	/** The event for when a background operation has completed. */
	public static readonly METRIC_BACKGROUND_OPERATION_COMPLETED = "background-operation-completed";

	/** The metric to count each retry attempt during background operation polling */
	public static readonly METRIC_BACKGROUND_OPERATION_POLLING_RETRY = "background-operation-polling-retry";

	/** The metric to count unexpected errors thrown during background operation polling */
	public static readonly METRIC_BACKGROUND_OPERATION_POLLING_ERROR = "background-operation-polling-error";

	/** The event for when a background operation is canceled in the UI. */
	public static readonly EVENT_BACKGROUND_OPERATION_CANCELED = "background-operation-canceled";

	/** The event for when the StateData is rebuilt after being found missing for a valid dispatched service. */
	public static readonly EVENT_ORPHANED_STATE_REBUILT = "orphaned-state-rebuilt";

	/** The event for when the StateData rebuild process determines another tab has already rebuilt the StateData. */
	public static readonly EVENT_ORPHANED_STATE_REBUILD_RACE_LOST = "orphaned-state-rebuild-race-lost";

	/** The event for when an orphan reconciliation pass finds at least one forward orphan (cache row missing its state row) to repair. */
	public static readonly EVENT_ORPHAN_RECONCILIATION_RUN = "orphan-reconciliation-run";
}